import script from "./HolidayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayPage.vue?vue&type=script&setup=true&lang=js"

import "./HolidayPage.vue?vue&type=style&index=0&id=515e1e3b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-515e1e3b"]])

export default __exports__